import { Routes, Route } from 'react-router-dom';
import { ArcheLayout } from '../../../components/ArcheLayout';
import { BetaAccessPublicPage } from './BetaAccessPublicPage';
import { BetaAccessAdminPage } from './BetaAccessAdminPage';

export function BetaAccessArchePage() {
  return (
    <Routes>
      {/* Admin page — full screen with no sidebar */}
      <Route
        path="/admin"
        element={
          <ArcheLayout displayMode="fullscreen">
            <BetaAccessAdminPage />
          </ArcheLayout>
        }
      />
      {/* Public form — full screen */}
      <Route
        path="/*"
        element={
          <ArcheLayout displayMode="fullscreen">
            <BetaAccessPublicPage />
          </ArcheLayout>
        }
      />
    </Routes>
  );
}
